/**
 * Chemins de l'API interne, rassemblés en un seul endroit.
 *
 * Le préfixe vient du contrat partagé (`PREFIXE_API_INTERNE`) : si la version de l'API change,
 * elle change ici et nulle part ailleurs. Les numéros de série sont encodés — ils contiennent
 * légitimement des espaces (`RE_NUMERO_SERIE` autorise l'espace) et casseraient l'URL sinon.
 */

import { PREFIXE_API_INTERNE } from '@genviz/shared/common';

const p = PREFIXE_API_INTERNE;

/** Encode un numéro de série pour un segment d'URL. */
export function segment(valeur: string): string {
  return encodeURIComponent(valeur);
}

export const CHEMINS = {
  /* Session STAFF */
  connexion: `${p}/auth/login`,
  rafraichissement: `${p}/auth/refresh`,
  deconnexion: `${p}/auth/logout`,
  moi: `${p}/me`,

  /* Tableau de bord */
  tableauDeBord: `${p}/dashboard`,

  /* Stock */
  stock: `${p}/stock`,
  importStock: `${p}/stock/import`,
  statutStock: (sn: string): string => `${p}/stock/${segment(sn)}/status`,

  /* Appareils */
  diagnostic: (sn: string): string => `${p}/devices/${segment(sn)}/diagnostic`,
  mesures: (sn: string): string => `${p}/devices/${segment(sn)}/measures`,
  desassociation: (sn: string): string => `${p}/devices/${segment(sn)}/unbind`,
  historiqueMesures: (sn: string): string => `${p}/devices/${segment(sn)}/history/measures`,
  historiqueTrames: (sn: string): string => `${p}/devices/${segment(sn)}/history/frames`,
  historiqueImpulsions: (sn: string): string => `${p}/devices/${segment(sn)}/history/pulses`,
  etalonnage: (sn: string): string => `${p}/devices/${segment(sn)}/calibration`,

  /* Exploitations */
  exploitations: `${p}/exploitations`,
  exploitation: (id: string): string => `${p}/exploitations/${segment(id)}`,
  statutExploitation: (id: string): string => `${p}/exploitations/${segment(id)}/status`,
  statutUtilisateur: (id: string): string => `${p}/users/${segment(id)}/status`,

  /* Supervision */
  carteSupervision: `${p}/supervision/map`,

  /* Journal d'audit */
  audit: `${p}/audit`,

  /* Exploitation commerciale */
  clients: `${p}/clients`,
  consommation: `${p}/consommation`,

  /* Programmation USB d'une carte neuve */
  flashDescription: `${p}/firmware/flash`,
  flashImage: `${p}/firmware/flash/image`,
  abonnements: `${p}/abonnements`,
  statutAbonnement: (id: string): string => `${p}/abonnements/${segment(id)}/statut`,
  tickets: `${p}/sav/tickets`,
  ticket: (id: string): string => `${p}/sav/tickets/${segment(id)}`,
  messagesTicket: (id: string): string => `${p}/sav/tickets/${segment(id)}/messages`,
  statutTicket: (id: string): string => `${p}/sav/tickets/${segment(id)}/statut`,
} as const;
